// Each HTML entry (served by ss-ui-node EJS templates) renders a "load cover" that
// masks the page until the entry bundle boots, then the bundle removes it. The main
// app template uses `#load-cover` (id); the auth templates (login, verify-email,
// resend-verification) use `.load-cover` (class). Centralizing the removal here keeps
// every entry consistent and — critically — guards against a missing element so an
// entry bundle can never crash at boot when its expected cover markup is absent.
const LOAD_COVER_SELECTOR = '.load-cover, #load-cover';

export const removeLoadCover = () => {
  const loadCover = document.querySelector(LOAD_COVER_SELECTOR);
  loadCover?.parentNode?.removeChild(loadCover);
};
